import { render } from "./NoAccess.vue?vue&type=template&id=d00db654&scoped=true"
import script from "./NoAccess.vue?vue&type=script&lang=js"
export * from "./NoAccess.vue?vue&type=script&lang=js"

import "./NoAccess.vue?vue&type=style&index=0&id=d00db654&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d00db654"]])

export default __exports__